import script from "./headerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./headerComponent.vue?vue&type=script&setup=true&lang=js"

import "./headerComponent.vue?vue&type=style&index=0&id=8cd6bb80&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cd6bb80"]])

export default __exports__